import { EServiceType as EServiceTypeRaw } from '../../../../repositories/billing-tariffs/entities/PublishTerms/RecommendedServicePackageServiceV2';
import { EServiceType } from '../../../../types/reducers/publishTerms';

const SERVICE_TYPES: { [key in EServiceTypeRaw]: EServiceType } = {
  [EServiceTypeRaw.Top3]: EServiceType.Top3,
  [EServiceTypeRaw.PremiumObject]: EServiceType.Premium,
  [EServiceTypeRaw.DebitObject]: EServiceType.Paid,
  [EServiceTypeRaw.Free]: EServiceType.Free,
  [EServiceTypeRaw.Auction]: EServiceType.Auction,
  [EServiceTypeRaw.Standard]: EServiceType.Standard,
};

export const mapServiceType = (serviceType: EServiceTypeRaw): EServiceType => {
  return SERVICE_TYPES[serviceType];
};
